/**
 * configurator API
 * configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import {CustomHttpUrlEncodingCodec} from '../encoder';

import {Observable} from 'rxjs';

import {FsTranslate} from '../model/fsTranslate';

import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';


@Injectable()
export class ConfiguratorTraductionService {

    protected basePath = 'https://dmp.airiane.com/services/configurator';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Obtenir une traduction d&#39;un ou plusieurs codes
     * Cette requête permet d&#39;obtenir une traduction d&#39;un ou plusieurs codes par type.&lt;br&gt;La requête prend en paramètre un ou plusieurs codes de traduction. Ce sont des abréviations de pays, villes, aeroports, etc.&lt;br&gt;Elle prend un type qui pourrait être : (pays, ville, airline, etc.)&lt;br&gt;Finalement, la requête prend aussi des isos de langue pour définir la langue de la traduction. La norme ISO 639-1 est utilisée.&lt;br&gt;Les isos disponibles sont : fr (Français), en (Anglais), it (Italien), de (Allemand), nl (Néerlandais), es (Espagnol).&lt;br&gt;La requête retourne une liste de traductions.
     * @param codes codes
     * @param isos isos
     * @param typeCode typeCode
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTraductionFromAirianeUsingGET1(codes: Array<string>, isos: Array<string>, typeCode: 'AIRPLANE' | 'AIRLINE' | 'AIRPORT' | 'CITY' | 'TERRITORY' | 'COUNTRY' | 'CONTINENT', observe?: 'body', reportProgress?: boolean): Observable<Array<FsTranslate>>;
    public getTraductionFromAirianeUsingGET1(codes: Array<string>, isos: Array<string>, typeCode: 'AIRPLANE' | 'AIRLINE' | 'AIRPORT' | 'CITY' | 'TERRITORY' | 'COUNTRY' | 'CONTINENT', observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<FsTranslate>>>;
    public getTraductionFromAirianeUsingGET1(codes: Array<string>, isos: Array<string>, typeCode: 'AIRPLANE' | 'AIRLINE' | 'AIRPORT' | 'CITY' | 'TERRITORY' | 'COUNTRY' | 'CONTINENT', observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<FsTranslate>>>;
    public getTraductionFromAirianeUsingGET1(codes: Array<string>, isos: Array<string>, typeCode: 'AIRPLANE' | 'AIRLINE' | 'AIRPORT' | 'CITY' | 'TERRITORY' | 'COUNTRY' | 'CONTINENT', observe: any = 'body', reportProgress = false): Observable<any> {

        if (codes === null || codes === undefined) {
            throw new Error('Required parameter codes was null or undefined when calling getTraductionFromAirianeUsingGET1.');
        }

        if (isos === null || isos === undefined) {
            throw new Error('Required parameter isos was null or undefined when calling getTraductionFromAirianeUsingGET1.');
        }

        if (typeCode === null || typeCode === undefined) {
            throw new Error('Required parameter typeCode was null or undefined when calling getTraductionFromAirianeUsingGET1.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (codes) {
            codes.forEach((element) => {
                queryParameters = queryParameters.append('codes', <any> element);
            });
        }
        if (isos) {
            isos.forEach((element) => {
                queryParameters = queryParameters.append('isos', <any> element);
            });
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [];

        return this.httpClient.get<Array<FsTranslate>>(`${this.basePath}/api/traduction/airiane/${encodeURIComponent(String(typeCode))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
